export default "__VITE_PUBLIC_ASSET__b806ed22__"